import {otsBaseApi} from "../ots-api";
import {
  TicketAppPreferenceProfile,
  TicketAppPreferenceProfileQuery
} from "../../model/ticket-app-preference-profile";
import {removeUndefined} from "../../util/util";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["TicketAppPreferenceProfile"]});

export const ticketAppPreferenceProfileApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    resolveTicketAppPreferenceProfile: builder.query<TicketAppPreferenceProfile, TicketAppPreferenceProfileQuery>({
      query: (arg) => ({
        url: "/preferences/ticket-app/profile",
        method: "GET",
        params: removeUndefined({
          ...arg
        })
      }),
      providesTags: (_result, _error, arg) => [
        {
          type: "TicketAppPreferenceProfile",
          id: [
            arg.category,
            arg.regionId,
            arg.companyId,
            arg.companyUnitId,
            arg.siteId,
            arg.containerId,
            arg.freightTypeId,
            arg.serviceTypeId
          ].join(":")
        }
      ]
    }),
  })
});

export const {
  useResolveTicketAppPreferenceProfileQuery,
} = ticketAppPreferenceProfileApi;
